module.exports = __webpack_public_path__ + "static/fintech_logo-bd371dba94183097fddc670437f51cd5.svg";